import React, { useEffect, useState } from "react";
import axios from "axios";
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
import SectionHeaderBlogs from "../header/SectionHeaderBlogs";
import LoadingBar from "../LoadingBar";

const categories = [
  { id: 6405, name: "Social trends" },
  { id: 93, name: "PR & Promotion" },
  { id: 96, name: "Tourists" },
  { id: 6410, name: "Special" },
  { id: 6416, name: "Big Cook" },
];

const Blogs = () => {
  const { t, i18n } = useTranslation();
  const [blogsByCategory, setBlogsByCategory] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      const result = {};
      await Promise.all(
        categories.map(async (cat) => {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_BIGC_BIGLINE_API_URL}/blogs/blogs_categories`,
              {
                status: "publish",
                orderby: "date",
                order: "desc",
                per_page: "6",
                page: "1",
                categories: cat.id,
                language: i18n.language.toUpperCase(),
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  "x-api-key": process.env.REACT_APP_BIGC_BIGLINE_API_KEY,
                },
              }
            );
            // Map image into blog object
            result[cat.id] = response.data.map((blog) => ({
              ...blog,
              friendlyURL: `${blog.link
                .replace("https://blog-corporate.bigc.co.th/", "/blogs/")
                .replace(/\/$/, "")}?id=${blog.id}`,
              /*image:
                blog._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                "https://via.placeholder.com/300",*/
            }));
          } catch (error) {
            console.error(`Error loading category ${cat.name}`, error);
            result[cat.id] = [];
          }
        })
      );
      setBlogsByCategory(result);
      setLoading(false);
    };

    fetchBlogs();
  }, []);

  return (
    <>
      <ProfileWithBackButtonHeader />
      {loading ? (
        <LoadingBar loading={loading} label="Loading..." />
      ) : (
        <div className="bg-[#f6f6f6] w-full pb-6">
          <div className="mx-6">
            <SectionHeaderBlogs
              name={t("blogs")}
              eventSection={true}
              seniorLayout={false}
            />
          </div>

          {categories
            .filter((cat) => (blogsByCategory[cat.id] || []).length > 0)
            .map((cat, index) => {
              const blogs = blogsByCategory[cat.id] || [];
              if (blogs.length === 0) return null;
              const bgColor = index % 2 === 0 ? "#ecfcd9" : "#f6f6f6"; // สลับสีพื้นหลัง

              return (
                <div
                  key={cat.id}
                  className="pb-10 pt-4"
                  style={{ backgroundColor: bgColor }}
                >
                  <h2 className="text-xl font-semibold text-gray-800 mb-3">
                    {cat.name}
                  </h2>
                  <Carousel
                    showArrows
                    showStatus={false}
                    showThumbs={false}
                    infiniteLoop
                    emulateTouch
                    renderIndicator={(onClickHandler, isSelected, index) => (
                      <li
                        key={index}
                        className={`VueCarousel-dot ${
                          isSelected ? "VueCarousel-dot--active" : ""
                        }`}
                        onClick={onClickHandler}
                      />
                    )}
                    className="VueCarousel-pagination--bottom-overlay"
                  >
                    <div className="px-3">
                      <div className="overflow-x-auto scrollbar-hide px-1">
                        <div className="flex gap-3 pl-1 pr-4">
                          {blogs.slice(0, 5).map((blog) => (
                           <a
  key={blog.id}
  href={blog.friendlyURL}
  rel="noopener noreferrer"
  className="
    min-w-[72vw] sm:min-w-[240px] lg:min-w-[280px]
    max-w-[72vw] sm:max-w-[240px] lg:max-w-[280px]
    bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition
  "

                              onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                  event: "blog_click",
                                  blog_id: blog.id,
                                  blog_title: blog.title.rendered,
                                  blog_category_id: cat.id,
                                  blog_category_name: cat.name,
                                  blog_url: blog.friendlyURL,
                                });
                              }}
                            >
                              {/* กรอบรูปสัดส่วน 16:9 */}
                              <div
                                className="aspect-[16/9] w-full overflow-hidden rounded-t-2xl"
                                style={{ aspectRatio: "16 / 9" }}
                              >
                                <img
                                  src={blog.image}
                                  alt={blog.title.rendered}
                                  className="w-full h-full object-cover"
                                  loading="lazy"
                                />
                              </div>

                               <div className="p-3 text-sm text-gray-800">
    <div
      className="line-clamp-2 font-medium"
                                  dangerouslySetInnerHTML={{
                                    __html: blog.title.rendered,
                                  }}
                                />
                              </div>
                            </a>
                          ))}

                          {blogs.length > 5 && (
                            <Link
                              to={`/blogs/category/${cat.id}`}
                              className="min-w-[157px] max-w-[157px] bg-blue-100 text-blue-700 flex flex-col justify-center items-center rounded-xl shadow-sm hover:bg-blue-200 transition"
                              onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                  event: "blog_see_more",
                                  blog_category_id: cat.id,
                                  blog_category_name: cat.name,
                                });
                              }}
                            >
                              <div className="text-sm font-medium px-2 text-center">
                                {t("see_more")} →
                              </div>
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </Carousel>
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};

export default Blogs;